import { render } from "./EmailFromSelect.vue?vue&type=template&id=54487474"
import script from "./EmailFromSelect.vue?vue&type=script&lang=js"
export * from "./EmailFromSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__